import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const REVIEWS = [{
  name: 'Megustaler C.',
  text: 'A mi hija de 9 años le encantó y ya la ha leído de principio a fin dos veces. A menudo se aburre con las historias bíblicas que ha escuchado mil veces, pero esta Biblia realmente cambió su relación con las Escrituras.'
}, {
  name: 'Julia Z.',
  text: '¡Mi hijo de 9 años lo lee todos los días antes de irse a dormir! Jamás aceptaría saltarse la lectura. Ya se convirtió en su rutina.'
}, {
  name: 'Quentin',
  text: 'La leí yo mismo para asegurarme de que fuera bíblicamente precisa antes de dársela a mi hijo de 10 años. Es precisa. Las ilustraciones contribuyen a la narración: es justo lo que los niños necesitan para disfrutar la lectura.'
}, {
  name: 'Franco',
  text: 'La leemos como devoción nocturna y cada noche me ruega que le lea más. Se sabía de memoria los libros de la Biblia para la iglesia, pero no entendía su significado hasta que leyó esto.'
}, {
  name: 'Ángela B.',
  text: 'Un libro de historias bíblicas con un estilo de cómic muy bonito: ¡a mi nieta de 7 años le fascinan las historias!'
}, {
  name: 'Alquilar (41 años)',
  text: 'Tengo 41 años. Nunca leí la Biblia completa y siempre me sentí un poco culpable: me parecía intimidante. Este libro me abrió las puertas y me dan ganas de abrir la Biblia original y volver a intentarlo.'
}];
function initials(name: string) {
  return name.trim().charAt(0).toUpperCase();
}
export function ReviewsSection() {
  return <section className="w-full bg-mist" data-id="element-147" data-mp="3vopw5fusehwe">
      <div className="mx-auto max-w-6xl px-4 py-16 md:py-20" data-id="element-148" data-mp="3vnocwo3map3l">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-bold leading-tight text-deep-blue md:text-[38px]" data-id="element-149" data-mp="4hn64rqoqhnr">
          Lo que dicen los padres y abuelos que ya apostaron por este formato
        </h2>

        <p className="mt-3 text-center text-sm text-ink/55 lg:hidden" data-id="element-150" data-mp="2p9f5xadop6eb">
          Desliza para ver más reseñas →
        </p>
        <div className="mt-6 -mr-4 flex snap-x snap-mandatory gap-4 overflow-x-auto pr-4 pb-3 sm:gap-5 lg:mr-0 lg:grid lg:grid-cols-3 lg:overflow-visible lg:pr-0 lg:pb-0" data-id="element-151" data-mp="urdulmr3pdfp">
          {REVIEWS.map((r, i) => <motion.figure key={r.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.45,
          delay: i % 3 * 0.08
        }} className="flex w-[86%] flex-none snap-start flex-col rounded-card border border-card-border bg-white p-6 shadow-soft sm:w-[58%] lg:w-auto" data-id="element-152" data-mp="l09gep991wlx" data-mpi={i}>
              <div className="mb-3 flex text-gold" aria-label="5 de 5 estrellas" data-id="element-153" data-mp="3u7sjuzxfyab7">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-gold" aria-hidden="true" data-id="element-154" data-mp="1wgpyyrg3otd0" data-mpi={s} />)}
              </div>
              <blockquote className="flex-1 text-[15px] text-ink/80" data-id="element-155" data-mp="1se356kzvcyd6">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3" data-id="element-156" data-mp="3fc3wjg26zhwv">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-deep-blue text-sm font-bold text-white" data-id="element-157" data-mp="3faanxv80qnm8">
                  {initials(r.name)}
                </span>
                <span className="text-sm font-semibold text-deep-blue" data-id="element-158" data-mp="3o71rststb6rd">
                  {r.name}
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}